import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CasosService } from './casos.service';
import { Caso } from './casos.model';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from '../core/service/notifications.service';
import { forkJoin } from 'rxjs';
import { ArbitrosService } from '../arbitros/arbitros.service';
import { getCurrentLanguage } from '../core/helpers/utils';
import { Sector, Idioma, Ciudad } from '../arbitros/varios.model';
import { AuthenticationService } from '../core/service/auth.service';

@Component({
  selector: 'app-caracteristicas-arbitraje',
  templateUrl: './caracteristicas-arbitraje.component.html',
  styleUrls: ['./caracteristicas-arbitraje.component.scss']
})
export class CaracteristicasArbitrajeComponent implements OnInit {

  @Output() refreshCase = new EventEmitter<void>();

  caso!: Caso;
  loaded: boolean = false;
  error: string = '';
  disableOptions: boolean = true;

  sectores: { label: string, value: string }[] = [];
  idiomas: { label: string, value: string }[] = [];
  ciudades: { label: string, value: string }[] = [];
  currentLanguage: string = getCurrentLanguage();

  private readonly origenOptionDefs = [
    { labelES: 'Cláusula CIIAM', labelEN: 'CIIAM Clause', value: 'CLAUSULA_CIAM_CIAR' },
    { labelES: 'Reenvío directo', labelEN: 'Direct referral', value: 'REENVIO_DIRECTO' },
    { labelES: 'Reenvío por acuerdo', labelEN: 'Referral by agreement', value: 'REENVIO_POR_ACUERDO' }
  ];

  private readonly procedimientoOptionDefs = [
    { labelES: 'Ordinario', labelEN: 'Ordinary', value: 'ORDINARIO' },
    { labelES: 'Abreviado', labelEN: 'Shortened', value: 'ABREVIADO' },
    { labelES: 'Híper-abreviado', labelEN: 'Ultra-shortened', value: 'HIPER_ABREVIADO' },
    { labelES: 'Emergencia', labelEN: 'Emergency', value: 'EMERGENCIA' }
  ];

  private readonly tipoOptionDefs = [
    { labelES: 'Derecho', labelEN: 'Law', value: 'DERECHO' },
    { labelES: 'Equidad', labelEN: 'Equity', value: 'EQUIDAD' }
  ];

  private readonly audienciasOptionDefs = [
    { labelES: 'Presencial', labelEN: 'In-person', value: 'PRESENCIAL' },
    { labelES: 'Híbrida', labelEN: 'Hybrid', value: 'HIBRIDA' },
    { labelES: 'Virtual', labelEN: 'Virtual', value: 'VIRTUAL' }
  ];

  origenOptions: { label: string, value: string }[] = [];
  procedimientoOptions: { label: string, value: string }[] = [];
  tipoOptions: { label: string, value: string }[] = [];
  audienciasOptions: { label: string, value: string }[] = [];

  constructor(
    private casosService: CasosService,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService,
    private arbitrosService: ArbitrosService,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.origenOptions = this.translateOptions(this.origenOptionDefs);
    this.procedimientoOptions = this.translateOptions(this.procedimientoOptionDefs);
    this.tipoOptions = this.translateOptions(this.tipoOptionDefs);
    this.audienciasOptions = this.translateOptions(this.audienciasOptionDefs);

    const id_caso = this.route.snapshot.paramMap.get('id');

    if (id_caso) {
      forkJoin({
        caso: this.casosService.getCaso(id_caso),
        sectores: this.arbitrosService.getSectores(),
        idiomas: this.arbitrosService.getIdiomas(),
        ciudades: this.arbitrosService.getCiudades()
      }).subscribe({
        next: ({ caso, sectores, idiomas, ciudades }) => {
          this.caso = caso;

          // Transformamos los datos para extraer los valores correctos
          this.sectores = sectores.map((sector: Sector) => ({
            label: sector[this.currentLanguage],
            value: sector.nombre
          }));

          this.idiomas = idiomas.map((idioma: Idioma) => ({
            label: idioma[this.currentLanguage],
            value: idioma.nombre
          }));

          this.ciudades = ciudades.map((ciudad: Ciudad) => ({
            label: ciudad[this.currentLanguage],
            value: ciudad.nombre_ciudad
          }));

          this.authService.currentUser().subscribe(user => {
            if (user?.nivel_acceso) {

              // Si soy admin no deshabilito opciones
              if (user.nivel_acceso == "ADMIN") {
                this.disableOptions = false;
              }
            }
            this.loaded = true;
          });




        },
        error: (error) => {
          console.error('Error al cargar los datos:', error);
          this.error = error;
          this.loaded = false;
        }
      });
    } else {
      this.error = 'No se encontró el ID del caso';
      this.loaded = false;
    }
  }

  isCaseClosed(): boolean {
    const estadosCerrados = ['CERRADO_LAUDO', 'CERRADO_ACUERDO', 'CERRADO_OTROS', 'CERRADO_REENVIO'];
    return estadosCerrados.includes(this.caso.estado ?? '');
  }

  private translateOptions(options: { labelES: string, labelEN: string, value: string }[]): { label: string, value: string }[] {
    const useEnglish = this.currentLanguage?.toUpperCase() === 'EN';
    return options.map(option => ({
      label: useEnglish ? option.labelEN : option.labelES,
      value: option.value
    }));
  }


  onSubmit(f: any): void {
    if (f.valid && this.caso.id) {
      const updatedData: any = {
        numero_expediente: this.caso.numero_expediente,
        //fecha_solicitud: this.caso.fecha_solicitud,
        objeto_contrato: this.caso.objeto_contrato,
        convenio_arbitral: this.caso.convenio_arbitral,
      };

      if (this.caso.origen) {
        updatedData.origen = this.caso.origen;
      }
      if (this.caso.sector) {
        updatedData.sector = this.caso.sector;
      }
      if (this.caso.idioma) {
        updatedData.idioma = this.caso.idioma;
      }
      if (this.caso.sede) {
        updatedData.sede = this.caso.sede;
      }
      if (this.caso.procedimiento) {
        updatedData.procedimiento = this.caso.procedimiento;
      }
      if (this.caso.tipo) {
        updatedData.tipo = this.caso.tipo;
      }
      if (this.caso.audiencias) {
        updatedData.audiencias = this.caso.audiencias;
      }

      this.casosService.updateCaso(this.caso.id, updatedData).subscribe({
        next: () => {
          const updateCasoSuccessMessage: string = $localize `:@@updateCasoSuccessMessage:Datos guardados correctamente`;
          this.notificationsService.showSuccessNotification(updateCasoSuccessMessage);
          this.refreshCase.emit();
        },
        error: (error) => {
          this.notificationsService.showErrorNotification(error)
          console.error('Error al guardar los cambios:', error);
        }
      });
    }
  }
}
